export const PAGE_LABELS = {
	LOADING: 'Loading labels...',
	ERROR: 'Failed to load labels. Please try again.',
	DELETE_LABEL_SUCCESS: 'Label deleted successfully'
} as const;
